import { FC, useEffect, useMemo, useState } from "react";
import festivalApi from "@features/landing/helpers/festivalApi";
import { useRouter } from "next/router";
import { scrollToElementById } from "@utils/ui";

import useRequestImmutable from "@shared/hooks/useRequestImmutable";
import FestivalCardsSort from "./sort";
import FestivalCardsListLoading from "./loading";
import FestivalCardsPagination from "./pagination";
import FestivalCardsList from "./list";
import { layoutCardsCount } from "@features/landing/helpers/constants/constants";
interface Props {
  slug: string;
}
const FestivalCards: FC<Props> = ({ slug }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [params, setParams] = useState();
  const { query } = useRouter();

  useEffect(() => {
    const { page, sort, category } = query;
    let params: any = {
      count: layoutCardsCount,
      sort: sort === "newest" ? "new" : "popularity",
      page: page && !isNaN(Number(page)) ? Number(page) : 1,
    };
    if (category && typeof category === "string") params.category_id = category;
    setParams(params);
  }, [query]);

  const { data: productData } = useRequestImmutable(
    festivalApi.getProducts(slug, params)
  );

  useEffect(() => {
    if (productData) {
      scrollToElementById("festivalCourseList", 360);
      setLoading(false);
    }
  }, [productData]);

  const isLoading = loading || !productData?.data?.products?.length;
  return (
    <section className="mb-16" id="festivalCourseList">
      <div className="max-w-[1280px] mx-auto px-6">
        <FestivalCardsSort />
        {isLoading ? (
          <FestivalCardsListLoading />
        ) : (
          <FestivalCardsList data={productData.data?.products || []} />
        )}
        {productData?.data.pagination &&
          layoutCardsCount < productData?.data.pagination.total && (
            <FestivalCardsPagination
              metaPagination={productData.data.pagination}
              startLoading={() => setLoading(true)}
            />
          )}
      </div>
    </section>
  );
};

export default FestivalCards;
